import { SearchableDropdownOption } from "./searchableDropdown.types";
import { normalizeText } from "utils/text.normalize.logic";

/** Finds the label for a single selected value. */
export const findSelectedLabel = (
  options: SearchableDropdownOption[],
  value?: string,
): string => options.find((option) => option.value === value)?.label ?? "";

/** Collects labels for a set of selected values. */
export const getSelectedLabels = (
  options: SearchableDropdownOption[],
  selectedValues: string[],
): string[] =>
  selectedValues
    .map((value) => options.find((option) => option.value === value)?.label)
    .filter((label): label is string => Boolean(label));

/** Builds display data for multi-select labels and counts. */
export const buildMultiSelectDisplay = (
  options: SearchableDropdownOption[],
  selectedValues: string[],
): {
  displayLabel: string;
  extraCount: number;
  fullLabel: string;
  labels: string[];
} => {
  if (selectedValues.length === 0) {
    return { displayLabel: "", extraCount: 0, fullLabel: "", labels: [] };
  }
  const labels = getSelectedLabels(options, selectedValues);
  const displayLabels = labels.slice(0, 2);
  const extraCount = Math.max(labels.length - displayLabels.length, 0);
  return {
    displayLabel: displayLabels.join(", "),
    extraCount,
    fullLabel: labels.join(", "),
    labels,
  };
};

/** Splits labels into two columns for tooltip rendering. */
export const splitLabels = (labels: string[]): [string[], string[]] => {
  if (labels.length <= 6) return [labels, []];
  const mid = Math.ceil(labels.length / 2);
  return [labels.slice(0, mid), labels.slice(mid)];
};
